import axios from 'axios';
import { API_URL } from './baseApi';

export const mainScreenApi = {
  getMainScreenApi: async () => {
    return await axios.get(`${API_URL}/v1/main-screen`);
  },
};
